import styled, { keyframes } from "styled-components";

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const MainContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  min-height: 100dvh;
`;

export const ContentCard = styled.div`
  animation: ${fadeIn} 0.6s ease-out;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  gap: 62px;
`;

export const IconContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;

  svg {
    margin-left: -35%;
  }
`;

export const Title = styled.h1`
  color: #fff;
  text-align: center;
  font-family: Figtree;
  font-size: 22px;
  font-weight: 700;
  line-height: 150%; /* 33px */
  letter-spacing: -0.11px;
`;

export const Label = styled.span`
  color: rgba(255, 255, 255, 0.59);
  text-align: center;
  font-family: Figtree;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: -0.21px;
  margin-top: -20px;
  text-decoration: ${(p) => (p.$underline ? "underline" : "none")};
  cursor: ${(p) => (p.$underline ? "pointer" : "default")};
`;

export const Subtitle = styled.span`
  color: #fff;
  text-align: center;
  font-family: Figtree;
  font-size: 16px;
  font-weight: 600;
  line-height: 150%; /* 24px */
  letter-spacing: -0.08px;
`;

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  align-items: center;
  justify-content: center;
`;
